import { render, staticRenderFns } from "./FakturPajakAdd.vue?vue&type=template&id=4465f4fc&scoped=true"
import script from "./FakturPajakAdd.vue?vue&type=script&lang=js"
export * from "./FakturPajakAdd.vue?vue&type=script&lang=js"
import style0 from "./FakturPajakAdd.vue?vue&type=style&index=0&id=4465f4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4465f4fc",
  null
  
)

export default component.exports